import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowFitTopRight24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconArrowFitTopRight24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M18.253 3a2.75 2.75 0 0 1 2.748 2.75v9.953a.75.75 0 1 1-1.5 0V5.75q0-.09-.012-.177L5.559 19.5h6.158a.75.75 0 0 1 0 1.5H3v-8.716h1.5v6.154L18.428 4.513a1 1 0 0 0-.175-.012H8.298a.75.75 0 0 1 0-1.5zM3.75 12.285H3a.75.75 0 0 1 1.5 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowFitTopRight24);
